import { IntelligencePayMethod } from '../../../api/intelligencePayments';
import { IntelligenceProductStatus } from '../../../api/ai';

export const ALL_INTEL_PAY_METHODS: IntelligencePayMethod[] = ['stripe', 'ves'];

export const INTEL_PAY_LABELS: Record<IntelligencePayMethod, string> = {
  stripe: 'Card (Stripe)',
  ves: 'Bolívares (VES)',
  binance: 'USDT (Binance)',
};

export const FALLBACK_INTEL_CATALOG = [
  { id: 'lite', name: 'Lite', monthlyPrice: 0, monthlyCredits: 0 },
  { id: 'plus', name: 'Plus', monthlyPrice: 0, monthlyCredits: 0 },
  { id: 'extra', name: 'Extra', monthlyPrice: 0, monthlyCredits: 0 },
];

export type IntelligencePurchase = {
  kind: 'capacity' | 'pack';
  capacityId?: 'lite' | 'plus' | 'extra';
  packId?: string;
  name: string;
  unitPrice: number;
  credits?: number;
};

export const defaultIntelPayMethod = (
  allowed: IntelligencePayMethod[]
): IntelligencePayMethod =>
  allowed.includes('ves') ? 'ves' : allowed[0] ?? 'stripe';

export const allowedPayMethodsFromStatus = (
  status: IntelligenceProductStatus | null | undefined
): IntelligencePayMethod[] => {
  const raw = status?.paymentMethodsAllowed;
  if (Array.isArray(raw) && raw.length > 0) {
    const filtered = raw.filter((m): m is IntelligencePayMethod =>
      ALL_INTEL_PAY_METHODS.includes(m as IntelligencePayMethod)
    );
    if (filtered.length > 0) return filtered;
  }
  return ALL_INTEL_PAY_METHODS;
};

export const catalogFromStatus = (status: IntelligenceProductStatus | null | undefined) =>
  status?.catalog?.length ? status.catalog : FALLBACK_INTEL_CATALOG;
